











































































































































































import {Component, Vue} from "vue-property-decorator";
import UpdatePersonDetailsPayload from "@/dto/person/UpdatePersonDetailsRequestDTO";
import PhoneInput from "@/components/util/PhoneInput.vue";
import {WorkspaceTypePathElement} from "@/dto/auth/Workspace";
import UserDTO from "@/dto/UserDTO";
import {namespace} from "vuex-class";
import RouteNames from "@/router/RouteNames";
import ErrorLocalePathUtils from "@/utils/ErrorLocalePathUtils";
import PersonDTO from "@/dto/person/PersonDTO";
import PersonService from "@/services/PersonService";
import AddressDTO from "@/dto/AddressDTO";
import Workspaces from "@/state/Workspaces";
import PortalInput from "@/components/common/PortalInput.vue";
import {ifValid} from "@/utils/ComponentUtils";
import EmployeeService from "@/services/EmploymentService";
import {IEmployment} from "@/dto/payroll/IEmployment";
import PortalDate from "@/components/common/PortalDate.vue";
import {PersonSex} from "@/constants/PersonConstants";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import HistorySlider from "@/components/history/HistorySlider.vue";
import Notifications from "@/state/Notifications";
import History from "@/components/history/History.vue";
import SelectOption from "@/components/common/SelectOption";
import PortalSelect from "@/components/new_style_components/PortalSelect.vue";
import ChangeActions from "@/components/history/dto/ChangeActions";

const AppModule = namespace("App");
const Auth = namespace("Auth");

@Component({
	computed: {
		ChangeActions() {
			return ChangeActions
		}
	},
    components: {PortalSelect, History, HistorySlider, SingleFileHolder, PortalInput, PhoneInput, PortalDate}
})
export default class PersonDetails extends Vue {

    payload = new UpdatePersonDetailsPayload();

    private person: PersonDTO | null = null;

	  private employments: Array<IEmployment> = [];

    @Auth.Getter("hasAdministrativePrivileges")
    private hasAdministrativePrivileges!: boolean;

    private address = "";

    private email = "";

    @AppModule.State
    private isMobile!: boolean;

    @AppModule.Action
    private startLoading!: () => void;

    @AppModule.Action
    private stopLoading!: () => void;

    @Auth.State
    private user!: UserDTO

    private isDataReady = false;

    private message = "";

    private successful = false;

    private individualHistory = false;
	private taxHistory = false

    get PersonSex() {
        return PersonSex;
    }

	get personSexOptions(): SelectOption[] {
		return Object.values(PersonSex).map(it => SelectOption.builder().title(this.$t(`profile.sex.${it}`).toString()).value(it).build())
	}

    get WorkspaceTypePathElement() {
        return WorkspaceTypePathElement;
    }

    mounted() {
		this.startLoading();
        Promise.all([this.loadPersonInfo(), this.loadEmployments()]).then(
			res => {
				this.successful = true;
				this.message = "";
				this.stopLoading();
			},
			err => this.errorHandle(err)
		)
    }

	private loadEmployments(): Promise<void> {
		this.message = "";
		this.successful = false;
		this.employments = []; // Очищаем массив перед загрузкой
		return EmployeeService.getAllEmploymentsByDetailsId().then(
			res => {
				if (res.data && Array.isArray(res.data)) {
					this.employments = [...res.data];
				}
			},
			err => {
				console.error('Error loading employments:', err); // Отладочная информация
				this.errorHandle(err)
			}
		)
	}

    private loadPersonInfo(): Promise<void> {
        this.message = "";
        this.successful = false;
        this.startLoading();
        return PersonService.getById(Workspaces.getCurrent.id).then(
            res => {
                this.isDataReady = true;
                this.mapPersonDTOToUpdatePersonRequest(res.data);
                this.successful = true;
                this.stopLoading();
            },
            err => {
                this.errorHandle(err)
            }
        )
    }

    private errorHandle(error: any) {
        this.successful = false;
        const param = error?.response?.data?.param ? { param: error?.response?.data?.param } : {}
        this.message = this.$t(ErrorLocalePathUtils.getPathForError(error), param) as string;
        this.stopLoading();
    }

  private mapPersonDTOToUpdatePersonRequest(resPerson: PersonDTO) {
    this.person = resPerson;
    this.payload.firstName = resPerson.firstName;
    this.payload.lastName = resPerson.lastName;
    this.payload.ssn = resPerson.ssn;
    this.payload.phone = resPerson.phone
    this.payload.birthDate = resPerson.birthDate
    this.payload.countryOfBirth = resPerson.countryOfBirth
    this.payload.nationality = resPerson.nationality
    this.payload.sex = resPerson.sex
    this.address = this.buildAddress(resPerson.address);
    this.payload.nationalTin = resPerson.nationalTin
    this.email = resPerson.email ? resPerson.email : "No email";
  }

    private buildAddress(address: AddressDTO | null) : string {
        if (!address) return "No address";
        return (address.city ? address.city.concat(" ") : " ")
            .concat(address.state as string).concat(" ")
            .concat(address.address1 ? address.address1 as string : address.foreignAddress as string).concat(" ")
            .concat(address.zipCode);
    }

    private successHandle() {
        this.loadPersonInfo();
        this.stopLoading();
        this.successful = true;
        this.message = this.$t("util.success.person_details") as string;
    }


  private savePersonalInfo() {
    this.message = "";
    ifValid(this, () => {
      this.startLoading();
      this.payload.personId = Workspaces.getCurrent.id;
      PersonService.updatePersonDetails(this.payload).then(
          () => {
            this.successHandle();
            Notifications.success("Personal information updated successfully!");
          },
          (error) => {
            this.errorHandle(error)
          }
      ).then(() => this.stopLoading());
    })
  }

  private saveTaxInfo() {
    this.message = "";
    ifValid(this, () => {
      this.startLoading();
      this.payload.personId = Workspaces.getCurrent.id;
      PersonService.updatePersonDetails(this.payload).then(
          () => {
            this.successHandle();
            this.message = "Tax information updated successfully!";
          },
          (error) => {
            this.errorHandle(error)
          }
      ).then(() => this.stopLoading());
    })
  }

    private redirectToAccountSettings() {
        this.$router.push({name: RouteNames.PROFILE_ACCOUNT, params: {type: 'p', id: String(Workspaces.getCurrent.id)}});
    }

    private redirectToAddressSettings() {
        this.$router.push({name: RouteNames.PROFILE_ADDRESS, params: {type: 'p', id: String(Workspaces.getCurrent.id)}});
    }
}
